module.exports = __webpack_public_path__ + "static/img/1692694590405.f29a2e3d.jpg";